import { useCallback, useState } from "react";

export const useOpenState = (initialOpenStatus: boolean = false): [boolean, () => void, () => void, () => void] => {
  const [opened, setOpened] = useState<boolean>(initialOpenStatus);

  const open = useCallback(() => {
    setOpened(true);
  }, [setOpened]);

  const close = useCallback(() => {
    setOpened(false);
  }, [setOpened]);

  const toggle = useCallback(() => {
    setOpened((state) => !state);
  }, [setOpened]);

  return [opened, open, close, toggle];
};
